module.exports = __webpack_public_path__ + "media/images/pic/hero/trees-86a92e5522c95b5cc84a9eaf94151a22.png";